import { WorkflowDescriptionSkeleton } from '../../ProjectCanvas/Canvas/WorkflowDescription/WorkflowDescriptionSkeleton';
import React from 'react';
import { TextField } from '@mui/material';
import './WorkflowDescriptionField.css';

export const WorkflowDescriptionField = ({
  publishing = false,
  workflow,
  title = 'Workflow Description',
}) => {
  return (
    <>
      <p className={'s-text'}>{title}</p>
      <p className={'s-text workflow-description-subtitle'}>
        This description is automatically updated using AI when you publish
      </p>
      <div className="workflow-description-field-container">
        {publishing ? (
          <div className="workflow-description-skeleton-wrapper">
            <WorkflowDescriptionSkeleton />
          </div>
        ) : (
          <div className="workflow-description-textfield-wrapper">
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              multiline
              rows={5}
              readOnly
              className="workflow-description-readonly"
              InputProps={{
                readOnly: true,
              }}
              placeholder={workflow?.description || 'No description provided for this workflow'}
              value={workflow?.description || ''}
            />
          </div>
        )}
      </div>
    </>
  );
};
